import script from "./UtilLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./UtilLinks.vue?vue&type=script&setup=true&lang=js"

import "./UtilLinks.vue?vue&type=style&index=0&id=7cce2db2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cce2db2"]])

export default __exports__